// Constant values here, such as string names, etc

export const example = "Example Text";
export const accessRequestSuccess =
  "Request sent successfully. If approved you will receive an email with instructions to finish account setup.";

export interface AppRouteOption {
  label: string;
  value: string;
}

export interface IconOption {
  label: string;
  value: string;
}

export const ICON_OPTIONS: IconOption[] = [
  // Charts & Data
  { label: "chart-area", value: "fa-solid fa-chart-area" },
  { label: "chart-bar", value: "fa-solid fa-chart-bar" },
  { label: "chart-column", value: "fa-solid fa-chart-column" },
  { label: "chart-gantt", value: "fa-solid fa-chart-gantt" },
  { label: "chart-line", value: "fa-solid fa-chart-line" },
  { label: "chart-pie", value: "fa-solid fa-chart-pie" },
  { label: "chart-simple", value: "fa-solid fa-chart-simple" },
  { label: "database", value: "fa-solid fa-database" },
  { label: "table", value: "fa-solid fa-table" },
  { label: "table-cells", value: "fa-solid fa-table-cells" },
  { label: "table-columns", value: "fa-solid fa-table-columns" },
  // Files & Documents
  { label: "book", value: "fa-solid fa-book" },
  { label: "book-open", value: "fa-solid fa-book-open" },
  { label: "clipboard", value: "fa-solid fa-clipboard" },
  { label: "clipboard-check", value: "fa-solid fa-clipboard-check" },
  { label: "clipboard-list", value: "fa-solid fa-clipboard-list" },
  { label: "file", value: "fa-solid fa-file" },
  { label: "file-arrow-down", value: "fa-solid fa-file-arrow-down" },
  { label: "file-chart-column", value: "fa-solid fa-file-chart-column" },
  { label: "file-code", value: "fa-solid fa-file-code" },
  { label: "file-csv", value: "fa-solid fa-file-csv" },
  { label: "file-excel", value: "fa-solid fa-file-excel" },
  { label: "file-export", value: "fa-solid fa-file-export" },
  { label: "file-invoice", value: "fa-solid fa-file-invoice" },
  { label: "file-invoice-dollar", value: "fa-solid fa-file-invoice-dollar" },
  { label: "file-lines", value: "fa-solid fa-file-lines" },
  { label: "file-pdf", value: "fa-solid fa-file-pdf" },
  { label: "file-word", value: "fa-solid fa-file-word" },
  { label: "folder", value: "fa-solid fa-folder" },
  { label: "folder-open", value: "fa-solid fa-folder-open" },
  { label: "folder-tree", value: "fa-solid fa-folder-tree" },
  { label: "newspaper", value: "fa-solid fa-newspaper" },
  { label: "note-sticky", value: "fa-solid fa-note-sticky" },
  // Navigation & Layout
  { label: "bars", value: "fa-solid fa-bars" },
  { label: "border-all", value: "fa-solid fa-border-all" },
  { label: "diagram-project", value: "fa-solid fa-diagram-project" },
  { label: "grip", value: "fa-solid fa-grip" },
  { label: "home", value: "fa-solid fa-home" },
  { label: "layer-group", value: "fa-solid fa-layer-group" },
  { label: "list", value: "fa-solid fa-list" },
  { label: "list-check", value: "fa-solid fa-list-check" },
  { label: "map", value: "fa-solid fa-map" },
  { label: "sitemap", value: "fa-solid fa-sitemap" },
  {
    label: "square-poll-horizontal",
    value: "fa-solid fa-square-poll-horizontal",
  },
  { label: "square-poll-vertical", value: "fa-solid fa-square-poll-vertical" },
  // Users & People
  { label: "address-card", value: "fa-solid fa-address-card" },
  { label: "briefcase", value: "fa-solid fa-briefcase" },
  { label: "id-badge", value: "fa-solid fa-id-badge" },
  { label: "id-card", value: "fa-solid fa-id-card" },
  { label: "people-group", value: "fa-solid fa-people-group" },
  { label: "person", value: "fa-solid fa-person" },
  { label: "user", value: "fa-solid fa-user" },
  { label: "user-check", value: "fa-solid fa-user-check" },
  { label: "user-clock", value: "fa-solid fa-user-clock" },
  { label: "user-gear", value: "fa-solid fa-user-gear" },
  { label: "user-tie", value: "fa-solid fa-user-tie" },
  { label: "users", value: "fa-solid fa-users" },
  { label: "users-gear", value: "fa-solid fa-users-gear" },
  // Finance & Business
  { label: "building", value: "fa-solid fa-building" },
  { label: "building-columns", value: "fa-solid fa-building-columns" },
  { label: "calculator", value: "fa-solid fa-calculator" },
  { label: "cash-register", value: "fa-solid fa-cash-register" },
  {
    label: "circle-dollar-to-slot",
    value: "fa-solid fa-circle-dollar-to-slot",
  },
  { label: "coins", value: "fa-solid fa-coins" },
  { label: "credit-card", value: "fa-solid fa-credit-card" },
  { label: "dollar-sign", value: "fa-solid fa-dollar-sign" },
  { label: "hand-holding-dollar", value: "fa-solid fa-hand-holding-dollar" },
  { label: "money-bill", value: "fa-solid fa-money-bill" },
  { label: "money-bill-wave", value: "fa-solid fa-money-bill-wave" },
  { label: "money-check", value: "fa-solid fa-money-check" },
  { label: "receipt", value: "fa-solid fa-receipt" },
  { label: "sack-dollar", value: "fa-solid fa-sack-dollar" },
  { label: "scale-balanced", value: "fa-solid fa-scale-balanced" },
  // Settings & Admin
  { label: "bolt", value: "fa-solid fa-bolt" },
  { label: "circle-nodes", value: "fa-solid fa-circle-nodes" },
  { label: "code", value: "fa-solid fa-code" },
  { label: "cog", value: "fa-solid fa-cog" },
  { label: "cogs", value: "fa-solid fa-cogs" },
  { label: "hammer", value: "fa-solid fa-hammer" },
  { label: "key", value: "fa-solid fa-key" },
  { label: "lock", value: "fa-solid fa-lock" },
  { label: "screwdriver-wrench", value: "fa-solid fa-screwdriver-wrench" },
  { label: "shield-halved", value: "fa-solid fa-shield-halved" },
  { label: "sliders", value: "fa-solid fa-sliders" },
  { label: "toggle-on", value: "fa-solid fa-toggle-on" },
  { label: "wrench", value: "fa-solid fa-wrench" },
  // Communication & Info
  { label: "bell", value: "fa-solid fa-bell" },
  { label: "circle-info", value: "fa-solid fa-circle-info" },
  { label: "comment", value: "fa-solid fa-comment" },
  { label: "comments", value: "fa-solid fa-comments" },
  { label: "envelope", value: "fa-solid fa-envelope" },
  { label: "envelope-open-text", value: "fa-solid fa-envelope-open-text" },
  { label: "headset", value: "fa-solid fa-headset" },
  { label: "message", value: "fa-solid fa-message" },
  { label: "phone", value: "fa-solid fa-phone" },
  { label: "question", value: "fa-solid fa-question" },
  { label: "rss", value: "fa-solid fa-rss" },
  // Actions & Tools
  {
    label: "arrow-right-from-bracket",
    value: "fa-solid fa-arrow-right-from-bracket",
  },
  { label: "calendar", value: "fa-solid fa-calendar" },
  { label: "calendar-check", value: "fa-solid fa-calendar-check" },
  { label: "calendar-days", value: "fa-solid fa-calendar-days" },
  { label: "clock", value: "fa-solid fa-clock" },
  { label: "download", value: "fa-solid fa-download" },
  { label: "filter", value: "fa-solid fa-filter" },
  { label: "flag", value: "fa-solid fa-flag" },
  { label: "link", value: "fa-solid fa-link" },
  { label: "magnifying-glass", value: "fa-solid fa-magnifying-glass" },
  {
    label: "magnifying-glass-chart",
    value: "fa-solid fa-magnifying-glass-chart",
  },
  { label: "print", value: "fa-solid fa-print" },
  { label: "rotate", value: "fa-solid fa-rotate" },
  { label: "share-nodes", value: "fa-solid fa-share-nodes" },
  { label: "star", value: "fa-solid fa-star" },
  { label: "thumbtack", value: "fa-solid fa-thumbtack" },
  { label: "upload", value: "fa-solid fa-upload" },
  // Transport & Logistics
  { label: "box", value: "fa-solid fa-box" },
  { label: "boxes-stacked", value: "fa-solid fa-boxes-stacked" },
  { label: "car", value: "fa-solid fa-car" },
  { label: "car-side", value: "fa-solid fa-car-side" },
  { label: "gas-pump", value: "fa-solid fa-gas-pump" },
  { label: "road", value: "fa-solid fa-road" },
  { label: "route", value: "fa-solid fa-route" },
  { label: "truck", value: "fa-solid fa-truck" },
  { label: "truck-fast", value: "fa-solid fa-truck-fast" },
  { label: "warehouse", value: "fa-solid fa-warehouse" },
];
